<p class="mt-3 font-weight-bold">Abstimmungsergebnis</p>
<p *ngIf="quest && quest.text">{{quest.text}}</p>
<div class="chart">
  <canvas baseChart
          [data]="pieChartData"
          [type]="pieChartType">
  </canvas>
</div>
